<template>
  <b-col cols="12" sm="1" class="left-navbar-container">
    <div class="left-navbar pt-5 d-flex flex-column justify-content-between">
      <ul>
        <li v-for="item in items" :key="item.name" :class="{ active: $route.name === item.name }">
          <router-link :to="{ name: item.name}" class="icon-container">
            <i class="material-icons">{{ item.icon }}</i>
            <p class="d-none d-sm-inline">{{ item.text }}</p>
          </router-link>
        </li>
      </ul>
      <ul>
        <li id="logout">
          <router-link :to="{ name: 'logout'}" class="icon-container">
            <i class="material-icons">power_settings_new</i>
            <p class="d-none d-sm-inline"> Logout</p>
          </router-link>
        </li>
      </ul>
    </div>
  </b-col>
</template>
<script>
export default {
  name: 'ConfigLeftNav',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      isCache: false,
      isConfig: false
    }
  },
  methods: {
    isActive (name) {
      return this.$route.name === name
    }
  }
}
</script>

<style lang="scss" scoped>
.left-navbar-container {
  min-height: calc(100vh - 60px);
  padding: 0;
  min-width: 200px;
}

.left-navbar {
  position: fixed;
  min-width: 200px;
  // width: 100%;
  background-color: rgb(65, 72, 81);
  color: rgb(255, 255, 255);
  height: calc(100vh - 60px);

  ul {
    padding: 0;

    &.push-bottom {
      position: absolute;
      bottom: 0;
    }

    li {
      list-style: none;

      &:hover {
        background-color: rgb(106, 111, 118);
      }

      a {
        color: #FFFFFF;
        padding: 30px;
        display: block;
        width: 100%;
        height: 100%;

        &:hover {
          text-decoration: none;
        }
      }

      &.active {
        background-color: rgb(106, 111, 118);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheLeftNav.vue